<template>
  <div class="recommend">
    <div class="left">
      <div class="flex">
        <div class="title flex" style="margin-left: 30px;">
          <span>推荐院校
            <select name="" style="width: 100px;" @change="changeLevel" v-model="edu">
              <option value="" disabled selected>请选择</option>
              <option v-for=" item in options.edu_list" :value="item.value">{{item.label}}</option>
            </select>
            <select name="" style="width: 100px;" @change="changeLevel" v-model="province_id">
              <option value="" disabled selected>请选择</option>
              <option v-for="item1 in options.province_list" :value="item1.value">{{item1.label}}</option>
            </select>
          </span>

        </div>
        <div class="more" @click="jump('/schoolList')"><span>更多</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="block">
        <el-carousel indicator-position="outside" height="250px">
          <el-carousel-item :key="index" v-for="(item1,index) in data">
            <ul class="flex">
              <li v-for="(item,index) in item1" @click="jump(`schoolDetail?id=${item.id}`)">
                <img :src="'https://yunzhixuanpro.fw366.cn/'+item.badge_img">
                <span>{{item.school_name}}</span>
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>
        <!-- <ul class="flex">
          <li v-for="(item,index) in data" @click="jump(`schoolDetail?id=${item.id}`)">
            <img :src="item.logo">
            <span>{{item.school_name}}</span>
          </li>
        </ul> -->

      </div>
    </div>
    <!-- <div class="right">
      <div class="title1 flex">
        <span style="text-indent: 18px;">大学排行</span>
        <div class="more" @click="jump('/rank')"><span>更多</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="list">
        <ul>
          <li v-for="(item,index) in school" class="flex" @click="goDetail(item)">
            <div>
              <span class="rank">{{index+1}}</span>
              <span class="name">{{item.school_name}}</span>
            </div>
            <span class="hot">{{item.hot}}热度</span>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
  import {
    jump
  } from '../../../static/function.js'
  export default {
    data() {
      return {
        data: [],
        selectClassEnd: '',
        school: [],
        options: [],
        value: '',
        province_id: '',
        edu: ''
      }
    },
    created() {
      this.$http.indexRecommend().then(res => {
        this.data = res.data.list
      })
      this.$http.getIndexRecommend().then(res => {
        console.log(res)
        this.options = res.data
      })
    },
    methods: {
      goDetail(item) {
        this.$router.push('/schoolDetail?id=' + item.id)
      },
      changeLevel(event) {
        this.data = []
        let params = {
          province_id: this.province_id,
          edu: this.edu,
          type: 1
        }
        this.$http.indexRecommend(params).then(res => {
          this.data = res.data.list
        })
        console.log(this.data)
      },

    }
  }
</script>

<style scoped lang="scss">
  $color:'#C10B17';

  ul {
    margin-top: 30px;
  }

  li {
    width: 100%;
    margin-bottom: 13px;
    text-align: left;
  }

  li:hover {
    font-size: 20px;
    cursor: pointer;
  }

  .hot {
    color: #FFA200;
  }

  .rank {
    width: 20px;
    height: 20px;
    background: #FF0000;
    display: inline-block;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
    border-radius: 5px;
  }

  .rank1 {
    background: #FF7F7F;
  }

  .rank2 {
    background: #FFCCCC;
  }

  .rank3 {
    background: #F2F2F2;
  }

  .more {
    display: inline-block;
    float: right;
  }

  .right {
    width: 300px;
    float: left;
    margin-top: 33px;
    margin-left: 40px;
  }

  .block {
    margin: 0px 0 0 26px;
  }

  .left {
    margin-top: 31px;
    width: 98%;
    float: left;
  }

  .title {
    // width: 100px;
    position: relative;
    line-height: 18px;
  }

  .title1 {
    /*  width: 200px; */
    position: relative;
    line-height: 18px;
  }

  .title::before {
    content: "";
    width: 4px;
    height: 18px;
    position: absolute;
    top: 0px;
    left: 0;
    background: $color;
  }

  .title1::before {
    content: "";
    width: 4px;
    height: 18px;
    position: absolute;
    top: 0;
    left: 0;
    background: $color;
  }

  .recommend {
    width: 1280px;
    // height: 400px;
    background: #FFFFFF;
    margin: 22px auto;
    overflow: hidden;
    box-shadow: 0px 1px 29px 1px rgba(0, 0, 0, 0.03);
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .flex {
    justify-content: space-between;
    margin: 0 0px;

  }

  .flex li {
    width: 140px;
    list-style: none;
    text-align: center;
  }

  img {
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 50%;
    margin: 40px auto;
  }
</style>
<style scoped>
  .el-carousel__container {
    position: relative;
    height: 300px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/recommend.vue